import { DRAWER_PROPERTY_EDITOR_WIDTH } from '@editor/src/js/constants';
import { observable, reaction } from 'mobx';
import { IRightSideBarManager } from './right-side-bar-manager.interface';
import { ToolbarService, InjectorService } from '@tencent/workbench';
export default class RightSideBarManager implements IRightSideBarManager {
    @observable
    public isPropertyEditorShown = false;
    @observable
    public propertyEditorShowAction = 0;
    @observable
    public isAnimationEditorShown = false;
    // 侧边栏选择窗格是否展示
    @observable public isSelectWindowShown = false;
    // 评分侧边栏是否显示
    @observable public isSlideRatingShown = false;
    // 联网搜图侧边栏是否显示
    @observable public isReplaceImageShown = false;
    // 机器审核侧边栏是否显示
    @observable public isMachineAuditShown = false;

    public selectWindowShowAction = 0; // 展开选择窗格所要做的额外操作
    public selectWindowWidth = DRAWER_PROPERTY_EDITOR_WIDTH; // 记录选择窗格宽度

    /**
     * 监听窗格的开关，强制更新渲染组件，确保隐藏角标按钮是否禁用ui的渲染
     */
    public constructor() {
        const toolbarService = InjectorService.get(ToolbarService);
        reaction(
            () => this.isAnimationEditorShown,
            () => {
                toolbarService.$forceUpdate();
            },
        );
    }

    public setIsPropertyEditorShown = (isPropertyEditorShown: boolean) => {
        this.isPropertyEditorShown = isPropertyEditorShown;
    };

    public setPropertyEditorShowAction = (propertyEditorShowAction: number) => {
        this.propertyEditorShowAction = propertyEditorShowAction;
    };

    public setIsAnimationEditorShown = (isAnimationEditorShown: boolean) => {
        this.isAnimationEditorShown = isAnimationEditorShown;
    };

    public setIsSelectWindowShown = (isSelectWindowShown: boolean) => {
        this.isSelectWindowShown = isSelectWindowShown;
    };

    public setSelectWindowShowAction = (selectWindowShowAction: number) => {
        this.selectWindowShowAction = selectWindowShowAction;
    };

    public setSelectWindowWidth = (selectWindowWidth: number) => {
        this.selectWindowWidth = selectWindowWidth;
    };

    public setReplaceImageShown = (isReplaceImageShown: boolean) => {
        this.isReplaceImageShown = isReplaceImageShown;
    };

    public setMachineAuditShown = (isMachineAuditShown: boolean) => {
        this.isMachineAuditShown = isMachineAuditShown;
    };

    /**
     * 设置侧边栏排版建议面板是否展示
     */
    public setIsSlideRatingShown = (isSlideRatingShown: boolean) => {
        this.isSlideRatingShown = isSlideRatingShown;
    };
}
